import { IProduct } from "../type/IProduct";
import { IProductMap } from "../type/IProductMap";
import { getProductsByIds } from "./getProductsByIds";

export const initRecentProducts = (productMap: IProductMap): IProduct[] => {
  const recentIdsString = localStorage.getItem("recents");
  if (!recentIdsString) return [];
  const recentProductIds = recentIdsString.split(",");
  return getProductsByIds(recentProductIds, productMap);
}